import { z, isoZ } from 'my-zod'

export const customAssetClassCategories = [
  'Airplane',
  'Auto/Jeep',
  'Bike',
  'Boat',
  'Cabin',
  'Camp Site',
  'Camper',
  'Canoe',
  'Construction Equipment',
  'Dirt Bike',
  'Drone',
  'E-Bike',
  'Fishing Gear',
  'Generator',
  'Golf Cart',
  'Hiking/Mtn Climbing Equipment',
  'Kayak',
  'Paddleboard/Surfboard',
  'PWC',
  'Raft',
  'Room',
  'RV',
  'Scooter',
  'Scuba Gear',
  'Skis',
  'Snowshoes',
  'Sports Equipment',
  'Tent',
  'Trailer',
  'Zipline',
  'Other'
] as const

export const customAssetClassModel = z.object({
  id: z.number().int(),
  name: z
    .string({
      invalid_type_error: 'Name is required',
      required_error: 'Name is required'
    })
    .min(1, 'Name must contain at least 1 character')
    .max(50, 'Name must contain at most 50 characters'),
  outfitterId: z.number().int(),
  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant(),
  deletedDate: isoZ.instant().nullable(),
  imageUrl: z.string().nullable(),
  category: z.enum(customAssetClassCategories).nullable()
})

export type customAssetClassModel = z.infer<typeof customAssetClassModel>
